<template>
  <p class="mb-3 text-[13px] leading-5 md:mb-2">{{ props.experienceOption.description }}</p>
  <!-- 768〜1023px の 2 カラムでは左カラムが 440px まで縮むため、横並びは lg から（md からだと名前が 1 文字ずつ折れて価格と重なる） -->
  <div class="flex flex-col gap-y-4 border border-gray1 p-4 lg:flex-row lg:justify-between" data-testid="experience-event-option-card">
    <div class="flex">
      <!-- イベントオプション画像 -->
      <OptimizedImage
        :alt="props.experienceOption.mainImageFilepath"
        :class="['mr-4 aspect-[3/2] h-[60px] w-[90px] object-cover md:h-[80px] md:w-[120px]']"
        :image-url="props.experienceOption.mainImageFilepath"
        :optimized-image-options="{ width: 120 }"
      />
      <div class="max-w-[160px] text-sm md:text-xs">
        <p class="mb-2 line-clamp-3 text-sm md:text-xs">{{ props.experienceOption.name }}</p>
        <AtomsPrimaryTextButton aria-label="detail" :data-testid="`detail-button-${props.experienceOption.id}`" :on-click="onClickDetail">
          <span>detail</span>
        </AtomsPrimaryTextButton>
      </div>
    </div>
    <div class="flex items-center justify-between">
      <p class="mr-6 text-base text-gold1">{{ formattedPrice }}</p>
      <div class="flex w-[146px] justify-center rounded-sm border-[0.5px] border-gold1">
        <button
          class="flex items-center justify-center"
          type="button"
          :class="props.disabled ? 'cursor-not-allowed opacity-40' : 'hover:opacity-90 active:opacity-80'"
          :disabled="props.disabled"
          @click.prevent="emits('decrement')"
        >
          <img src="@/assets/img/minus.svg" />
        </button>
        <AtomsParagraph4 class="flex flex-1 items-center justify-center">
          <span :data-testid="`experience-option-${props.experienceOption.id}-count`">{{ props.count }}</span>
        </AtomsParagraph4>
        <button
          class="flex items-center justify-center"
          data-testid="incrementButton"
          type="button"
          :class="props.disabled ? 'cursor-not-allowed opacity-40' : 'hover:opacity-90 active:opacity-80'"
          :disabled="props.disabled"
          @click.prevent="emits('increment')"
        >
          <img src="@/assets/img/plus.svg" />
        </button>
      </div>
    </div>
  </div>
  <ExperienceEventOptionDetailModal
    :count="props.count"
    :data-testid="`experienceEventOptionDetailModal-${props.experienceOption.id}`"
    :disabled="props.disabled"
    :experience-option="props.experienceOption"
    :is-open="isOpen"
    :is-public-price="props.isPublicPrice"
    :on-close="close"
    @decrement="emits('decrement')"
    @increment="emits('increment')"
  />
</template>

<script lang="ts" setup>
import { useModal } from '@/composables/ui/useModal';
import type { WabunkaExperienceEventOptionViewModel } from '@/models/wabunka/wabunkaExperienceEventOption';
import type { WabunkaExperienceOptionViewModel } from '@/models/wabunka/wabunkaExperienceOption';
import { OptimizedImage } from '@/wabunka-src/common/components';
import { ExperienceEventOptionDetailModal } from '@/wabunka-src/features/Experience';
interface Props {
  disabled?: boolean;
  experienceOption: WabunkaExperienceEventOptionViewModel | WabunkaExperienceOptionViewModel;
  count: number;
  // 価格を表示するか否か
  isPublicPrice: boolean;
}

const props = defineProps<Props>();
const { isOpen, close, open } = useModal();

const onClickDetail = () => {
  open();
};
const emits = defineEmits(['increment', 'decrement']);

const formattedPrice = computed(() => {
  if (props.isPublicPrice) {
    return `JPY ${props.experienceOption.priceIncludingTax.toLocaleString()}`;
  }
});
</script>
